// extracted by mini-css-extract-plugin
export default {"avatar":"_1pnhn","menu":"_3ewkO","popoverContent":"_2piD3","mobileButton":"_2c7jM"};